import { initOnce } from '@/generic/init';
import { provideRule } from '@/rule/RuleProvider.ts';
import { inject } from '@/rule/injections.ts';
import { RULES_REPOSITORY } from '@/rule/RuleKeys.ts';

const RULE_KEY = Symbol('Rule');

export { Category } from '@/rule/domain/Category.ts';
export { Categories } from '@/rule/domain/Categories.ts';
export { Example, ExampleCompliance } from '@/rule/domain/Example.ts';
export { Examples } from '@/rule/domain/Examples.ts';
export { RuleId } from '@/rule/domain/RuleId.ts';
export { Rules } from '@/rule/domain/Rules.ts';
export type { RulesRepository } from '@/rule/domain/RulesRepository.ts';
export { RulesFilter } from '@/rule/domain/RulesFilter.ts';
export { RulesScope } from '@/rule/domain/RulesScope.ts';
export { Description, Rule, Severity, Title } from '@/rule/domain/Rule.ts';
export { RuleDetailsComponent } from '@/rule/primary/RuleDetailsComponent.tsx';
export { RuleHeadingComponent } from '@/rule/primary/RuleHeadingComponent.tsx';
export { useRuleIdText } from '@/rule/primary/UseRuleIdText.ts';
export { useSeverityText } from '@/rule/primary/UseSeverityText.ts';
export { RuleStatus } from '@/rule/domain/RuleStatus.ts';

export const initRule = () => {
  initOnce(RULE_KEY, provideRule);

  return {
    injectRulesRepository: () => inject(RULES_REPOSITORY),
  };
};
